<template>

    <div>


        <!-- El DIALOG para agregar nuevo padecimiento -->
            <v-dialog v-model="dialogAgrega" width="800" persistent>
                <v-card>
                    <v-form
                        v-model="validaDiagForm"
                        ref="validaDiagForm"

                        @submit="agregaDiag"
                        onSubmit="return false;"
                    >
                        <v-card-title
                            class="headline green lighten-2 white--text"
                            primary-title
                            
                        >
                            Agrega PROCEDIMIENTO
                        </v-card-title>

                        <v-card-text class="pt-5">


                            <!-- El autocomplete de los diagnosticos -->
                            <v-autocomplete
                                append-outer-icon="mdi-magnify"
                                @click:append-outer='abreBuscaDiag'
                                
                                v-model="nuevoProc.procedimiento"
                                
                                :items="listaPadecimienos"
                                :loading="loadingBuscaPad"
                                
                                label="Procedimiento (CIE-9 opcional)"
                                :search-input.sync="queryPad"
                                item-text="codigo"
                                item-value="id"

                                no-filter

                                filled
                                rounded
                                outlined
                                dense
                                no-data-text='No ha datos para mostrar'
                                
                            >
                                <!-- El template para la lista de los datos -->
                                <template v-slot:item="data">
                                    <v-list-item-content>
                                        <v-list-item-title>{{data.item.codigo}} - {{data.item.padecimiento}}</v-list-item-title>
                                        <v-list-item-subtitle>{{data.item.capitulo}}</v-list-item-subtitle>
                                        <v-list-item-subtitle>{{data.item.seccion}}</v-list-item-subtitle>
                                    </v-list-item-content>
                                </template>

                                
                                <!-- El template para el control de paginate -->
                                <template v-slot:append-item>
                                    <v-pagination
                                        v-model="pageAc"
                                        circle
                                        :length="pageLengthAc"
                                        total-visible="7"
                                        :disabled="loadingBuscaPad"
                                    ></v-pagination>
                                </template>

                                <template v-slot:selection="data">
                                    ({{data.item.codigo}}) {{data.item.padecimiento}}
                                </template>



                            </v-autocomplete>


                            <v-text-field
                                v-model="nuevoProc.procedimientoNombreComun"

                                :rules="[
                                    value => !!value || 'Requerido.',
                                ]"

                                filled
                                rounded
                                outlined
                                dense

                                label="Procedimiento (nombre común)"
                            />

                            
                            <v-row no-gutters> 
                                <v-col xs="12" sm="12" md="6" lg="6" xl="6" cols="12">
                                    Anestesia
                                    <v-radio-group v-model="nuevoProc.anestesia">
                                        <v-row > 
                                            <v-col cols="4">
                                                <v-radio label="General" :value="1"></v-radio>
                                            </v-col>
                                            <v-col cols="4">
                                                <v-radio label="Regional" :value="2"></v-radio>
                                            </v-col>
                                            <v-col cols="4">
                                                <v-radio label="Sedación" :value="3"></v-radio>
                                            </v-col>
                                            <v-col cols="4">
                                                <v-radio label="Local" :value="4"></v-radio>
                                            </v-col>
                                            <v-col cols="4">
                                                <v-radio label="Combinada" :value="5"></v-radio>
                                            </v-col>
                                            <v-col cols="4">
                                                <v-radio label="No se usó" :value="6"></v-radio>
                                            </v-col>
                                        </v-row>
                                    </v-radio-group>

                                </v-col>
                                
                                <v-col xs="12" sm="12" md="6" lg="6" xl="6" cols="12" class="px-5">
                                    <div class="d-flex justify-center">
                                        <v-checkbox
                                            v-model="nuevoProc.quirofano"
                                            label="En quirófano"
                                            false-value=0
                                            true-value=1

                                        />
                                    </div>
                                    <v-scroll-y-transition>
                                        <div v-if="nuevoProc.quirofano == 1" class="d-flex justify-center">
                                            <v-text-field
                                                class="pr-2"
                                                v-model="nuevoProc.horas"
                                                filled
                                                rounded
                                                outlined
                                                dense
                                                type="number"
                                                label="Horas"
                                            />
                                            <v-text-field
                                                class="pl-2"
                                                v-model="nuevoProc.minutos"
                                                filled
                                                rounded
                                                outlined
                                                dense
                                                type="number"
                                                label="Minutos"
                                            />
                                        </div>
                                    </v-scroll-y-transition>
                                </v-col>
                            </v-row>

                            <v-autocomplete
                                v-model="nuevoProc.cirujano"
                                
                                :items="listaMedicos"
                                :loading="loadingMedico"
                                
                                label="Médico/cirujano"
                                :search-input.sync="queryMed"
                                item-text="username"
                                item-value="username"

                                no-filter

                                filled
                                rounded
                                outlined
                                dense
                                no-data-text='No hay datos para mostrar'
                                
                            >
                                <!-- El template para la lista de los datos -->
                                <template v-slot:item="data">
                                    <v-list-item-content>
                                        <v-list-item-title>{{data.item.nombreCompleto}} - {{data.item.especialidad}}</v-list-item-title>
                                        <v-list-item-subtitle>CÉDULA: {{data.item.cedula}}/CURP: {{data.item.curp}}</v-list-item-subtitle>
                                    </v-list-item-content>
                                </template>

                                <template v-slot:selection="data">
                                    {{data.item.nombreCompleto}} - {{data.item.especialidad}}
                                </template>

                            </v-autocomplete>

                            
                            

                            
                        </v-card-text>

                        <v-card-actions>
                            <v-spacer/>
                            <v-btn color="error" @click="cancela">
                                Cerrar
                            </v-btn>

                            <v-btn
                                color="success"
                                type="submit"
                                :disabled="!validaDiagForm"
                                :loading="loadingDiagForm"
                            >
                                Agrega
                            </v-btn>
                        </v-card-actions>
                    </v-form>
                </v-card>
            </v-dialog>

            <!-- Dialog para catálogo de diagnósticos -->
            <catalogo-procedimientos
                :dialogCatCie.sync='dialogCatCie'
                :listaPadecimienos.sync='listaPadecimienos'
                :esteDiagId.sync='nuevoProc.procedimiento'
            />

        
    </div>
</template>

<script>
import CatalogoProcedimientos from '@/components/procedimientos/catalogoProc'
export default {
    components:{
        'catalogo-procedimientos':CatalogoProcedimientos
    },

    props:{

        dialogAgrega:{
            type:Boolean,
        },
        paciente:{
            type:Number,
        },
        internamiento:{
            type:Number,
        },
        //listaPadecimienos:{
        //    type: Array,
        //},
        padPadecimiento:{
            type:Number,
        }


    },

    data:()=>({

        loadingDiagForm:false,
        validaDiagForm:false,

        nuevoProc:{
            procedimiento: null,
            procedimientoNombreComun: '',
            anestesia: 6,
            quirofano: 0,
            horas: null,
            minutos: null,
            cirujano: ''
        },

        

        // Para el autocomplete
        listaPadecimienos:[],
        loadingBuscaPad:false,
        queryPad:'',

        // Pagging del autocomplete
        paramsAc:{},

        // Para la paginación
        limitAc:10,
        pageAc:1,
        totalAc:0,

        // Para catálogo de diagnósticos:
        dialogCatCie:false,

        // Para el select de los médicos
        listaMedicos:[],
        loadingMedico:false,
        queryMed:'',


        
    }),

    methods:{
        
        async cargaPadecimientos(/*query*/){
            
            if (!this.loadingMeds){
                if (this.queryPad && this.queryPad.length >= 3){

                    this.loadingBuscaPad = true

                    this.paramsAc.diagnostico = this.queryPad
                    this.paramsAc.page = this.pageAc
                    this.paramsAc.start = (this.pageAc -1) * this.limitAc
                    this.paramsAc.limit = this.limitAc
        
                    try {
                        var resp = await this.$http
                        .get('/cie9mc/cie9mc/',{
                            params:this.paramsAc,
                        })
                        this.listaPadecimienos = resp.data.root
                        this.totalAc = resp.data.total
                        this.loadingBuscaPad = false
                        
                    } catch(err) {
                        console.log(err)
                        this.loadingBuscaPad = false
                        this.$store.dispatch('security/revisaError',err)
                    }
                }
            }
        },
        async cargaMedicos(/*query*/){
            
            if (!this.loadingMeds){
                if (this.queryMed && this.queryMed.length >= 3){

                    this.loadingMedico = true

                    let params = {query: this.queryMed, page:1, start:0, limit:25}
        
                    try {
                        var resp = await this.$http
                        .get('/principal/listaTrabajadores/',{
                            params:params,
                        })
                        this.listaMedicos = resp.data.root
                        this.loadingMedico = false
                        
                    } catch(err) {
                        console.log(err)
                        this.loadingMedico = false
                        this.$store.dispatch('security/revisaError',err)
                    }
                }
            }
        },
        cancela(){
            this.$refs.validaDiagForm.reset()
            this.dialog = false
        },

        async agregaDiag(){

            this.loadingDiagForm=true

            let params = {...this.nuevoProc}
            params.paciente = this.paciente
            params.internamiento = this.internamiento

            try{
                let nd = await this.$http({
                    method:'POST',
                    url:'/hospital/guardaProcedimiento',
                    params:params
                })
                
                this.loadingDiagForm=false

                if (nd.data.estado == 'true'){
                    this.$refs.validaDiagForm.reset()
                    this.dialog=false
                    this.$emit('agregado')
                } else {
                    this.$swal.fire({
                        icon: 'warning',
                        title: 'No se puede guardar',
                        text: 'Verifique los datos e intente de nuevo',
                    })
                }




            } catch(err){
                this.loadingDiagForm=false
                this.$store.dispatch('security/revisaError',err)
            }

            //console.log(this.nuevoDiag)
        },

        abreBuscaDiag(){
            this.dialogCatCie=true
            //console.log('Buscar un nuevo padecimiento CIE 10')
        },
    },

    computed:{
        // dialog
        dialog:{
            get(){
                return this.dialogAgrega
            },
            set(val){
                this.$emit('update:dialogAgrega',val)
            },
        },
        // list
        // padecimientoSelected

        // pageLengthAc
        pageLengthAc(){
            return (Math.ceil(this.totalAc / this.limitAc));
        },

    },

    watch:{
        queryPad(){
            this.pageAc = 1
            this.cargaPadecimientos()
            
            
        },

        queryMed(){
            this.pageAc = 1
            this.cargaMedicos()
        },
        pageAc(){
            
            this.cargaPadecimientos()
        }

    },
}
</script>

<style>

</style>